import { StateModel } from './StateModel';
var ExternalLoginService = /** @class */ (function () {
    function ExternalLoginService() {
    }
    ExternalLoginService.prototype.getStateModel = function (state) {
        var orgstr = window.atob(state);
        var model = new StateModel();
        model.provider = orgstr.split(':')[0];
        model.returnUrl = orgstr.split(':')[1];
        return model;
    };
    ExternalLoginService.prototype.getState = function (state) {
        var orgstr = state.provider + ':' + state.returnUrl;
        return window.btoa(orgstr);
    };
    return ExternalLoginService;
}());
export default ExternalLoginService;
